import { useMemo } from "react"
import DOMPurify from "dompurify"

export type InnerHTMLProps = Omit<React.HTMLAttributes<HTMLDivElement>, "children"> & {
  value: string
  ref?: React.Ref<HTMLDivElement>
}

export const PotentiallyUnsafeInnerHtml = ({ value, ...otherProps }: InnerHTMLProps) => {
  const memoizedValue = useMemo(() => {
    return { __html: DOMPurify.sanitize(value) }
  }, [value])

  return (
    <div
      // oxlint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={memoizedValue}
      {...otherProps}
    />
  )
}
